var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('core-multi-lang',{directives:[{name:"show",rawName:"v-show",value:(_vm.showHeader),expression:"showHeader"}],attrs:{"back-path":_vm.getCheckinInforScreenUrl}}),_c('InfoStep')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }